import React, { Component } from 'react'
import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { formatBrlCents, formatDateTime } from '../../helpers/format'

/**
 * Credit ledger history for a user (GET /users/:id/ledger).
 * Does not load or display messages/chat.
 */
class FormLedger extends Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            pagination: {},
            loading: false,
            error: null,
        }
    }

    componentDidMount() {
        if (this.props.userId) {
            this.fetchLedger()
        }
        this._onTabShown = () => {
            if (this.props.userId) {
                this.fetchLedger()
            }
        }
        const link = document.getElementById('menuLedgerNavLink')
        if (link) {
            link.addEventListener('click', this._onTabShown)
        }
    }

    componentWillUnmount() {
        const link = document.getElementById('menuLedgerNavLink')
        if (link) {
            link.removeEventListener('click', this._onTabShown)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.userId && this.props.userId !== prevProps.userId) {
            this.fetchLedger()
        }
    }

    fetchLedger = () => {
        const { userId } = this.props
        if (!userId) {
            return
        }

        this.setState({ loading: true, error: null })
        const url = `${process.env.REACT_APP_API_HOST}/users/${userId}/ledger`

        axios.get(url)
            .then(resp => {
                const payload = resp.data && resp.data.data !== undefined ? resp.data.data : resp.data
                const list = Array.isArray(payload)
                    ? payload
                    : (payload && Array.isArray(payload.data) ? payload.data : [])
                const pagination = (!Array.isArray(payload) && payload) ? {
                    current_page: payload.current_page,
                    last_page: payload.last_page,
                    total: payload.total,
                    to: payload.to,
                    from: payload.from,
                } : { total: list.length }

                this.setState({ list, pagination, loading: false })
            })
            .catch(e => {
                this.setState({ loading: false, list: [], error: 'Falha ao carregar extrato' })
                if (!e.response) {
                    toastr.error('Erro', 'Falha ao carregar extrato de créditos')
                    console.log(e)
                } else if (e.response.data && e.response.data.message) {
                    toastr.error('Erro', e.response.data.message)
                } else {
                    toastr.error('Erro', 'Falha ao carregar extrato de créditos')
                }
            })
    }

    render() {
        if (!this.props.userId) {
            return <p className="text-muted">Salve o usuário para ver o extrato de créditos.</p>
        }

        const { list, loading, pagination, error } = this.state

        return (
            <div>
                <p className="text-muted mb-3">
                    Histórico de créditos (ledger). Mensagens e conversas não são exibidas neste admin.
                </p>
                {loading && <p>Carregando…</p>}
                {error && <p className="text-danger">{error}</p>}
                {!loading && list.length === 0 && (
                    <p className="text-muted">Não há lançamentos neste extrato.</p>
                )}
                {list.length > 0 && (
                    <>
                        <div className="table-responsive">
                            <table className="table table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Direção</th>
                                        <th>Valor</th>
                                        <th>Saldo após</th>
                                        <th>Motivo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((row) => (
                                        <tr key={row.id || `${row.created_at}-${row.reason}`}>
                                            <td>{formatDateTime(row.created_at)}</td>
                                            <td>
                                                {row.direction === 'credit' ? 'Crédito'
                                                    : row.direction === 'debit' ? 'Débito'
                                                        : (row.direction || '—')}
                                            </td>
                                            <td>{formatBrlCents(row.amount_cents)}</td>
                                            <td>{formatBrlCents(row.balance_after_cents)}</td>
                                            <td>{row.reason || '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {pagination.total != null && (
                            <p className="text-muted small mb-0">
                                {pagination.total} lançamento(s)
                            </p>
                        )}
                    </>
                )}
            </div>
        )
    }
}

export default FormLedger
